/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import { Spin } from 'antd'

class Homepage extends React.Component {
  static defaultProps = {}
  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <h1>欢迎使用台风体育后台管理系统</h1>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}
export default withRouter(connect(mapStateToProps, actions)(Homepage))



// WEBPACK FOOTER //
// ./src/containers/Homepage/index.js